<template>


  <div class="cf nau-shell">


    <!-- ================= NAGLOWEK ================= -->
    <header v-if="headFoot" class="nau-header">
      <div class="nau-header__inner">

        <a class="nau-header__brand" href="https://nau.pl" aria-label="NAU – strona główna">
          <img class="nau-header__logo" src="static/logo.svg" alt="NAU">
        </a>

        <nav class="nau-nav" :class="{ 'nau-nav--open': isOpen }" aria-label="Menu główne">
          <a class="nau-nav__link" href="https://nau.pl/produkty-ubezpieczeniowe/">Produkty ubezpieczeniowe</a>
          <a class="nau-nav__link" href="https://nau.pl/ubezpieczenia-grupowe/">Ubezpieczenia grupowe</a>
          <a class="nau-nav__link" href="https://nau.pl/likwidacja-szkod/">Likwidacja szkód</a>
          <a class="nau-nav__link" href="https://nau.pl/klub-nau/">Klub NAU</a>
          <a class="nau-nav__link" href="https://nau.pl/strefa-multiagenta/">Strefa Multiagenta</a>
          <a class="nau-nav__link" href="https://nau.pl/kontakt/">Kontakt</a>

          <!-- akcje w rozwinietym menu mobilnym -->
          <div class="nau-nav__actions">
            <a v-if="loggedIn && !isClientV" class="cf-btn cf-btn--ghost" @click="gotoclient(); isOpen = false">Strefa klienta</a>
            <a v-if="!loggedIn" class="cf-btn cf-btn--primary" data-bs-toggle="modal" data-bs-target="#loginDialog" @click="isOpen = false">Zaloguj się</a>
            <a v-if="loggedIn" class="cf-btn cf-btn--quiet" @click="doLogout">Wyloguj</a>
          </div>
        </nav>

        <div class="nau-header__actions">
          <a v-if="loggedIn && !isClientV" class="cf-btn cf-btn--ghost" @click="gotoclient">Strefa klienta</a>
          <a v-if="!loggedIn" id="login-button" class="cf-btn cf-btn--primary nau-header__login" data-bs-toggle="modal" data-bs-target="#loginDialog">Zaloguj się</a>
          <a v-if="loggedIn" class="cf-btn cf-btn--quiet" @click="doLogout">Wyloguj</a>

          <button type="button" class="nau-burger" :class="{ 'nau-burger--open': isOpen }" @click="isOpen = !isOpen"
                  :aria-expanded="isOpen ? 'true' : 'false'" aria-label="Menu">
            <span></span><span></span><span></span>
          </button>
        </div>

      </div>
    </header>



    <LPopup/>
    <ForgotPassword/>


    <loading-screen :is-loading="isLoading"></loading-screen>


    <main class="nau-main">
      <router-view :form="form"></router-view>
    </main>



    <!-- ================= STOPKA ================= -->
    <footer v-if="headFoot" class="nau-footer">
      <div class="nau-footer__inner">

        <div class="nau-footer__grid">

          <div class="nau-footer__brand">
            <img class="nau-footer__logo" src="static/logo.svg" alt="NAU">
            <p class="nau-footer__name">Nauczycielska Agencja<br>Ubezpieczeniowa SA</p>
            <p class="nau-footer__phone">Infolinia<br><a href="tel:226967270"><strong>22 696 72 70</strong></a></p>
          </div>

          <div class="nau-footer__col">
            <span class="nau-footer__title">Oferta</span>
            <a href="https://nau.pl/produkty-ubezpieczeniowe/">Produkty ubezpieczeniowe</a>
            <a href="https://nau.pl/likwidacja-szkod/">Likwidacja szkód</a>
            <a href="https://nau.pl/ubezpieczenia-grupowe/">Ubezpieczenia grupowe</a>
          </div>

          <div class="nau-footer__col">
            <span class="nau-footer__title">Dla klienta</span>
            <a href="https://nau.pl/klub-nau/">Klub NAU</a>
            <a href="https://nau.pl/strefa-multiagenta/">Strefa Multiagenta</a>
            <a href="https://nau.pl/aktualnosci/">Aktualności</a>
            <a href="https://nau.pl/centrum-prasowe/">Centrum prasowe</a>
          </div>

          <div class="nau-footer__col">
            <span class="nau-footer__title">Firma</span>
            <a href="https://nau.pl/o-firmie/">O firmie</a>
            <a href="https://nau.pl/kariera/">Kariera</a>
            <a href="https://nau.pl/dla-akcjonariuszy/">Dla akcjonariuszy</a>
            <a href="https://nau.pl/kontakt/">Kontakt</a>
          </div>

          <div class="nau-footer__col">
            <span class="nau-footer__title">Social media</span>
            <a class="nau-footer__social" href="https://www.facebook.com/NAUSA/" target="_blank" rel="noopener" aria-label="Facebook">
              <i class="fab fa-facebook-f"></i> Facebook
            </a>
          </div>

        </div>

        <div class="nau-footer__bottom">
          <div class="nau-footer__links">
            <a href="https://nau.pl/pelnomocnictwa/">Pełnomocnictwa</a>
            <a href="http://naukids.pl" target="_blank" rel="noopener">NAU Kids</a>
            <a href="https://nau.pl/polityka-prywatnosci/">Polityka prywatności</a>
          </div>
          <span class="nau-footer__copy">© {{ new Date().getFullYear() }} Nauczycielska Agencja Ubezpieczeniowa SA</span>
        </div>

      </div>
    </footer>


  </div>
</template>

<script>


  import Loader from "./components/Loader";

  import LPopup from "./components/LoginPopup";

  import ForgotPassword from './components/ForgotPasssword';

export default {
  name: 'NauPage',

    components: {
      'loading-screen': Loader,
      LPopup,
      ForgotPassword
    },


  computed: {

    // ukryj przycisk "Strefa klienta" gdy juz jestesmy w strefie klienta
    // (computed dziala tez przy bezposrednim wejsciu/odswiezeniu na /client)
    isClientV() {
      return this.$route.path === '/client';
    }
  },


  data() {
    return {

      // persystentny, globalny objekt wniosku przekazywany do kazdego widoku
      // przez <router-view :form="form">
      form: {},

      isLoading: false,
      loggedIn: false,
      isOpen: false,

      // registered by affiliate - otp login
      isRegisterLink: false,

      // user-friendly komunikat bledu przetwarzania wniosku (strona /pending)
      pendingMessage: '',

      headFoot: true,

      // wznowienie wniosku z panelu klienta: id pozyczki (loans.id) oraz id wniosku
      // internetowego (ireq_id = internet_loan_request_id) - po nim backend
      // odczytuje rachunki z analizy konta (GET /application/bank/<ireq_id>)
      loanId: null,
      leadId: null

    }
  },


  watch:{
  },



  methods: {

    doLogout(notoast=false){
      this.isOpen = !this.isOpen;
      // remove user from local storage to log user out
      localStorage.removeItem('user');

      this.loggedIn = false;


      this.$route.path != '/'
        && this.$router.push({path: '/'});


      // reset persystentnego objektu wniosku
      this.form = new Object();

      // wyczysc ewentualny komunikat bledu
      this.pendingMessage = '';


      !notoast
        && this.toast('Wylogowano!');
    },




    gotoclient() {

        this.$router.push({path: '/client'}).then( success => {return success});
    },


    gotologin() {

        this.$router.push({path: '/login'});
    },



    gotothanku() {

        this.$router.push({path: '/thankyou'});
    },



    gotokontox() {


        this.$router.push({path: 'kontox'});

    },




    foobar() {


        console.log('this is is roots 1 page')
    }

  },


  created() {

    let dt = localStorage.getItem('user');

      this.listen('logged_in', (data) => {
          this.loggedIn = data;
      });
      this.listen('next_step_fail', () => {
          /*console.log("elo");*/
          this.echo('ForgotPasswordModal',"stepFail");
      });

    this.listen('logged_in', (data) => {
      this.loggedIn = data;
    });



    this.get( '/session' )
    .then(response => {

      if (!!response.data) {
        let ok = !(response.data.IS_ERROR | 0);


        if ( ok && dt ) {

          this.loggedIn = JSON.parse(dt);
        }

      }
    })
    .catch(error => {

      !!dt && this.doLogout(true);

      // Error
      if (error.response) {
         //console.log(error.response);
      }
    });



    if (this.$route.path == '/pdf') {

      this.headFoot = false;
    }


  },


  mounted() {



    let uri = window.location.href.split('?');



     if (uri.length > 1 && /login/.test(uri[1]) ) {

        this.echo('login_dialog');
     }

   let uriForgotPassword = window.location.href.split('?');


    if (uri.length > 1 && /code=/.test(uriForgotPassword[1]) ) {

        let url_array = window.location.href.split('\/').join().split('?').join().split('code=')
        let tmp_token_before_regex=url_array[1]



        var tmp_token = tmp_token_before_regex.replace(/[#,]/g, "");
        /*console.log(tmp_token)*/
        this.echo('ForgotPasswordModal',tmp_token);
    }



    // wyciaga i czysci pojedynczy parametr z URL
    let uriToken = pName => {

      let url_array = window.location.href.split('\/').join().split('?').join().split( pName + '='),
          tmp_token_before_regex = url_array[1],
          token = tmp_token_before_regex.split('#');

      // clean param
      let params = new URLSearchParams(location.search);
      params.delete( pName );
      history.replaceState(null, '', '?' + params + location.hash);

      return token[0];
    };



    // register by link - prefill persystentnego objektu form danymi z OTP
    if (uri.length > 1 && /register=/.test(uri[1])) {


      let regToken = uriToken('register');


      if (!regToken) {

        this.log( '- OTP REGISTER - no token - skip' );
      }
      else {

        this.log( '- OTP REGISTER - ' + regToken );


        this.isLoading = true;

        this.get('/application/otp/' + regToken )

          .then(response => {

            this.isLoading = false;


            let f = this.getConf('fields_otp_mapping');

            if (!!response.data && !!f) {


              this.isRegisterLink = true;


              let ob = response.data,
                  has;


              // set little delay to give some render time.
              setTimeout( () => {

                // fill up form
                Object.keys(f).map( k => {


                    has = ob.hasOwnProperty( f[k] ) ? ob[ f[k] ] : f[k];


                    //cascade fields and parse

                    // cut the whitespaces / enters etc.. from portal app
                    if (/client_name|client_surname|client_email/.test(k)) {

                      this.$set(this.form, k, String(has).trim());
                    }
                    else if (/client_employment_income/.test(k)){

                      this.$set(this.form, k, parseInt(has | 0));
                    }
                    else if (/client_address[1-2]_building/.test(k)){

                      // limited by validation to 10 chars
                      if (String(has).length > 10) {

                        this.$set(this.form, k, String(has).substr(0,10));
                      }
                      else {

                        this.$set(this.form, k, has);
                      }
                    }
                    else if (/client_employment_type/.test(k)){

                      // test if valid employment value provided
                      if ([0,2,3,4,5,6,8,9,11,12,14,7,13,1].indexOf( (has | 0) ) > -1 ) {

                        this.$set(this.form, k, parseInt(has));
                      }
                      else {

                        // default employment type - 4 equals other
                        this.$set(this.form, k, 4);
                      }
                    }

                    // default
                    else {

                      this.$set(this.form, k, has);
                    }

                  });

              }, 500);

            }

          })
          .catch(error => {

            this.isLoading = false;

            this.log( '- OTP REGISTER - get otp data fail.' );
          });

      }

    }



    /*setTimeout(() => {
      this.isLoading = false
    }, 5000)*/
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /* ---------- szkielet strony ---------- */

  .nau-shell {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .nau-main {
    flex: 1 0 auto;
  }


  /* ---------- naglowek ---------- */

  .nau-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #fff;
    border-bottom: 1px solid var(--cf-line);
  }

  .nau-header__inner {
    max-width: var(--cf-maxw);
    margin: 0 auto;
    padding: 12px 32px;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .nau-header__brand {
    display: flex;
    align-items: center;
    flex: none;
  }

  .nau-header__logo {
    height: 42px;
    width: auto;
  }

  .nau-nav {
    display: flex;
    align-items: center;
    gap: 0;
    flex: 1 1 auto;
    justify-content: center;
    flex-wrap: wrap;
  }

  .nau-nav__link {
    font-size: 13px;
    font-weight: 500;
    color: var(--cf-ink-2);
    padding: 6px 9px;
    border-radius: var(--cf-r-pill);
    white-space: nowrap;
    transition: background .15s, color .15s;
  }

  .nau-nav__link:hover {
    color: var(--cf-orange-hover);
    background: var(--cf-orange-tint);
    text-decoration: none;
  }

  .nau-nav__actions {
    display: none;
  }

  .nau-header__actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: none;
  }

  .nau-header__actions .cf-btn {
    cursor: pointer;
  }

  .nau-header__login {
    font-size: 13px;
    padding: 11px 22px;
    min-height: 0;
  }

  .nau-burger {
    display: none;
    width: 42px;
    height: 42px;
    border: 1.5px solid var(--cf-line);
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    padding: 0;
  }

  .nau-burger span {
    display: block;
    width: 18px;
    height: 2px;
    border-radius: 2px;
    background: var(--cf-orange);
    transition: transform .2s, opacity .2s;
  }

  .nau-burger--open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .nau-burger--open span:nth-child(2) { opacity: 0; }
  .nau-burger--open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }


  @media (max-width: 1300px) {

    .nau-header__inner {
      padding: 10px 18px;
      gap: 16px;
      flex-wrap: wrap;
    }

    .nau-header__actions {
      margin-left: auto;
    }

    .nau-header__actions .cf-btn {
      display: none;
    }

    .nau-burger {
      display: flex;
    }

    .nau-nav {
      order: 3;
      flex-basis: 100%;
      display: none;
      flex-direction: column;
      align-items: stretch;
      gap: 2px;
      padding: 8px 0 12px;
      border-top: 1px solid var(--cf-line-soft);
    }

    .nau-nav--open {
      display: flex;
    }

    .nau-nav__link {
      padding: 12px 10px;
      font-size: 15px;
      border-radius: 8px;
    }

    .nau-nav__actions {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      padding: 12px 10px 0;
    }
  }


  /* ---------- stopka ---------- */

  .nau-footer {
    background: var(--cf-orange-hover);
    color: rgba(255,255,255,.85);
    margin-top: 48px;
  }

  .nau-footer__inner {
    max-width: var(--cf-maxw);
    margin: 0 auto;
    padding: 48px 32px 28px;
  }

  .nau-footer__grid {
    display: grid;
    grid-template-columns: 1.4fr repeat(4, 1fr);
    gap: 20px;
  }

  .nau-footer__brand {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .nau-footer__logo {
    height: 40px;
    width: auto;
    align-self: flex-start;
    background: #fff;
    border-radius: 8px;
    padding: 6px 10px;
  }

  .nau-footer__name,
  .nau-footer__phone {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
  }

  .nau-footer__phone strong {
    color: #fff;
    font-size: 17px;
  }

  .nau-footer__col {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .nau-footer__title {
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: .12em;
    text-transform: uppercase;
    color: var(--cf-teal);
    margin-bottom: 4px;
  }

  .nau-footer a {
    color: rgba(255,255,255,.85);
    font-size: 14px;
  }

  .nau-footer a:hover {
    color: #fff;
    text-decoration: underline;
  }

  .nau-footer__social i {
    margin-right: 6px;
  }

  .nau-footer__bottom {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid rgba(255,255,255,.15);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .nau-footer__links {
    display: flex;
    gap: 22px;
    flex-wrap: wrap;
  }

  .nau-footer__copy {
    font-size: 12.5px;
    color: rgba(255,255,255,.6);
  }


  @media (max-width: 900px) {

    .nau-footer__inner {
      padding: 36px 18px 24px;
    }

    .nau-footer__grid {
      grid-template-columns: 1fr 1fr;
      gap: 28px 20px;
    }

    .nau-footer__brand {
      grid-column: 1 / -1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/NauPage.vue